import { render } from "./AboutUs.vue?vue&type=template&id=46019e4c&scoped=true"
import script from "./AboutUs.vue?vue&type=script&lang=js"
export * from "./AboutUs.vue?vue&type=script&lang=js"

import "@/assets/styles/aboutus.scss?vue&type=style&index=0&id=46019e4c&lang=scss&scoped=true"

import exportComponent from "/home/djokic/Projects/mariv/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46019e4c"]])

export default __exports__